import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Account.css";

function Account({ setLoggedIn }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // ✅ Supports both storage keys
    const currentUser =
      JSON.parse(localStorage.getItem("currentUser")) ||
      JSON.parse(localStorage.getItem("loggedInUser"));

    if (currentUser) {
      setUser(currentUser);

      // 🗂️ Load only this user's orders
      const username = currentUser.username || currentUser.name || currentUser.email;
      const userOrdersKey = `orders_${username}`;
      const userOrders = JSON.parse(localStorage.getItem(userOrdersKey)) || [];
      setOrders(userOrders);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("loggedInUser");
    if (setLoggedIn) setLoggedIn(false);
    navigate("/login");
  };

  if (!user) return null;

  return (
    <div className="account-page">
      <h2>My Account</h2>

      {/* User Details Section */}
      <div className="account-details">
        <p><strong>Full Name:</strong> {user.name}</p>
        <p><strong>Email:</strong> {user.email}</p>
      </div>

      {/* Order History Section */}
      <div className="account-orders">
        <h3>Order History</h3>
        {orders.length === 0 ? (
          <p>No orders yet.</p>
        ) : (
          <div className="orders-grid">
            {orders.map((order, index) => (
              <div key={index} className="order-card">
                <img src={order.images?.[0] ?? "placeholder.png"} alt={order.name} />
                <div className="order-details">
                  <h4>{order.name}</h4>
                  <p>Price: ₹{order.price}</p>
                  <p>Quantity: {order.quantity}</p>
                  <p>Date: {order.date}</p>
                  <p>Subtotal: ₹{(order.price || 0) * (order.quantity || 1)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Logout Button */}
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}

export default Account;